import styled from 'styled-components';

export const FastLinkWrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
